var map = {
	"./cleaned/1.cleaned_floor.svg": "93a2",
	"./cleaned/2.cleaned_toilet.svg": "722f",
	"./cleaned/3.cleaned_shower.svg": "7ab3",
	"./cleaned/4.cleaned_sink.svg": "699c",
	"./cleaned/5.cleaned_mirro.svg": "38cf",
	"./cleaned/6.cleaned_stainless_steel.svg": "af8c",
	"./counter/45.people_counter.svg": "8faa",
	"./counter/50.counter.svg": "efb4",
	"./counter/51.counter_men.svg": "612b",
	"./counter/52.counter_woman.svg": "e3bd",
	"./counter/53.counter_handycap.svg": "7c04",
	"./fixed/192.fixed_soap_dispenser.svg": "0f4d",
	"./fixed/193.fixed_paper_dispenser.svg": "521a",
	"./fixed/194.fixed_coffee_machine.svg": "f29f",
	"./fixed/195.fixed_water_bar.svg": "73b1",
	"./fixed/27.fixed_shower.svg": "72e2",
	"./fixed/28.fixed_sink.svg": "0781",
	"./fixed/29.fixed_mirro.svg": "65b2",
	"./fixed/30.fixed_stainless_steel.svg": "f388",
	"./fixed/31.fixed_blockage.svg": "d783",
	"./fixed/32.fixed_door.svg": "6874",
	"./fixed/33.fixed_fluid_taps.svg": "9ea5",
	"./fixed/34.fixed_lightning.svg": "1c9b",
	"./fixed/35.fixed_broken_toilet.svg": "d87f",
	"./food/170.dining_room.svg": "ebd7",
	"./food/171.food_variety.svg": "3029",
	"./food/172.quality_of_the_food.svg": "5928",
	"./food/173.amount_of_the_food.svg": "f687",
	"./food/174.quality_of_cooking.svg": "93e3",
	"./food/175.side_courses.svg": "4e91",
	"./food/176.meat.svg": "6ac2",
	"./food/177.desserts.svg": "c053",
	"./food/178.vegetarian.svg": "3a59",
	"./food/179.salad_bar.svg": "5264",
	"./food/180.main_courses.svg": "568a",
	"./food/181.service.svg": "7eb3",
	"./food/182.dining_room_cleanlines.svg": "b3b7",
	"./food/183.plates_and_cutlery_cleanliness.svg": "dec7",
	"./food/184.product_inventory.svg": "76e7",
	"./food/185.furnichers.svg": "2ccd",
	"./food/186.toilets.svg": "e90c",
	"./kitchen/47.zone_is_dirty.svg": "e726",
	"./kitchen/612.Appliances.svg": "043e",
	"./kitchen/613.Frodktim.svg": "02ed",
	"./kitchen/614.Broken_chair.svg": "0477",
	"./kitchen/615.Broken_abinet.svg": "4573",
	"./kitchen/616.Micro.svg": "ca5c",
	"./kitchen/617.toaster.svg": "8a84",
	"./kitchen/618.Clogged_sink_malfunction.svg": "7c25",
	"./kitchen/619.Coffee_cooling_malfunction.svg": "fde0",
	"./kitchen/620.No_coffee_beans.svg": "1ced",
	"./kitchen/621.Machine_ailure.svg": "9186",
	"./kitchen/622.That_dirty.svg": "f574",
	"./kitchen/623.Dirty_refrigerator.svg": "09eb",
	"./kitchen/624.Dirty_ables.svg": "14bf",
	"./kitchen/625.Dirty_floor.svg": "16da",
	"./kitchen/626.Plates.svg": "62cd",
	"./kitchen/627.Selver_spone.svg": "43be",
	"./kitchen/628.Cold_drinks_cups.svg": "c855",
	"./kitchen/629.Hot_drink_cups.svg": "1cd8",
	"./kitchen/631.problem_sink.svg": "0ec6",
	"./kitchen/632.A_dripping_faucet.svg": "113a",
	"./kitchen/632.problem_lightning.svg": "8d23",
	"./kitchen/81.coffee_tea.svg": "e30f",
	"./kitchen/82.water_bar.svg": "8ce0",
	"./kitchen/83.disposable_dishes.svg": "b261",
	"./language/100.hebrew.svg": "417a",
	"./language/100.עברית.svg": "c086",
	"./language/101.español.svg": "fec0",
	"./language/102.français.svg": "137d",
	"./language/103.english.svg": "6d1a",
	"./language/104.русский.svg": "a6bd",
	"./language/105.italiano.svg": "ea6f",
	"./language/106.አማርኛ.svg": "36d6",
	"./language/107.português.svg": "c8cf",
	"./linked/400.room_link.svg": "96b7",
	"./linked/401.floor_link.svg": "9216",
	"./officials/42.supervise.svg": "7a77",
	"./officials/43.maintenance.svg": "a26d",
	"./officials/44.cleaner.svg": "1581",
	"./officials/45.tag_cleaner.svg": "436d",
	"./officials/46.zone_is_clean.svg": "4e44",
	"./officials/47.zone_is_dirty.svg": "1e98",
	"./officials/48.cleaner_arrived.svg": "ddf4",
	"./officials/49.start_clean_zone.svg": "aab0",
	"./officials/55.maintenance_fixed.svg": "3f39",
	"./officials/56.maintenance_problem.svg": "064c",
	"./officials/59.end_clean_zone.svg": "08ac",
	"./problem/18.problem_shower.svg": "8889",
	"./problem/187.problem_coffee_machine.svg": "bf13",
	"./problem/188.problem_water_bar.svg": "1aab",
	"./problem/19.problem_sink.svg": "9cca",
	"./problem/196.problem_urinals.svg": "094b",
	"./problem/197.blockage_toilet.svg": "470c",
	"./problem/198.appliance_problem.svg": "a551",
	"./problem/199.problem_broken_door.svg": "ee7d",
	"./problem/20.problem_mirro.svg": "3339",
	"./problem/200.problem_broken_door_lock.svg": "3c72",
	"./problem/200.problem_door_lock.svg": "1061",
	"./problem/201.problem_broken_toilet_seat.svg": "c949",
	"./problem/202.problem_broken_niagara.svg": "3720",
	"./problem/203.broken_hand_paper_dispenser_Hand_dryer.svg": "2514",
	"./problem/21.problem_stainless_steel.svg": "3736",
	"./problem/213.problem_bed_smell.svg": "487c",
	"./problem/214.problem_broken_toilet_handle.svg": "e876",
	"./problem/215.problem_handle_door.svg": "94b4",
	"./problem/217.wall_painting.svg": "f73c",
	"./problem/22.problem_blockage.svg": "1817",
	"./problem/220.problem_right_elevator.svg": "a817",
	"./problem/221.problem_left_elevator.svg": "4480",
	"./problem/223.problem_sink_blockage.svg": "c680",
	"./problem/224.electric_problem.svg": "0902",
	"./problem/226.problem_air_condition.svg": "a9dc",
	"./problem/23.problem_door.svg": "4970",
	"./problem/24.problem_fluid_taps.svg": "e7dd",
	"./problem/25.problem_lightning.svg": "a70b",
	"./problem/26.problem_broken_toilet.svg": "08b0",
	"./problem/56.maintenance_problem.svg": "9389",
	"./problem/57.problem_soap_dispenser.svg": "3011",
	"./problem/58.problem_paper_dispenser.svg": "d35e",
	"./problem/88.maintenance.svg": "58c6",
	"./reports/10.dirty_shower.svg": "d5e2",
	"./reports/108.partial_Information.svg": "f028",
	"./reports/11.dirty_sink.svg": "5414",
	"./reports/12.dirty_mirror.svg": "d1af",
	"./reports/13.dirty_stainless_steel.svg": "cc3a",
	"./reports/14.missing_paper_towel.svg": "0424",
	"./reports/15.missing_soap.svg": "a594",
	"./reports/16.missing_toilet_paper.svg": "56ae",
	"./reports/190.dirty_stairs.svg": "4295",
	"./reports/191.missing_toiletries.svg": "baf1",
	"./reports/191.toiletries.svg": "dcde",
	"./reports/204.rug.svg": "d013",
	"./reports/205.tables.svg": "0767",
	"./reports/206.kitchen.svg": "ba3a",
	"./reports/207.air_condition.svg": "01e6",
	"./reports/208.dirty_urinals.svg": "f7a1",
	"./reports/208.problem_urinals.svg": "a202",
	"./reports/209.blockage_toilet.svg": "b91d",
	"./reports/210.hand_dryer.svg": "af9a",
	"./reports/212.non-sticky_carpet.svg": "886c",
	"./reports/216.call_cleaner.svg": "e527",
	"./reports/218.missing_paper.svg": "876c",
	"./reports/219.clean_surface.svg": "304e",
	"./reports/222.missing_hend_sanitizer.svg": "52f7",
	"./reports/225.missing_coffe_tea.svg": "745f",
	"./reports/227.dishwashing.svg": "1847",
	"./reports/228.kitchen_cleanliness.svg": "8512",
	"./reports/229.weekly_cleaning.svg": "d62a",
	"./reports/230.general_arrangement.svg": "5772",
	"./reports/231.meeting_room.svg": "7d2a",
	"./reports/232.refrigerator.svg": "5ba6",
	"./reports/233.kitchen_supplies.svg": "d3b9",
	"./reports/234.toilet_services.svg": "a40d",
	"./reports/235.carousel_door.svg": "b916",
	"./reports/236.desk.svg": "9ce6",
	"./reports/237.compressor.svg": "c464",
	"./reports/238.compressor_rails.svg": "6f25",
	"./reports/239.compressor_drainage.svg": "1685",
	"./reports/240.dust.svg": "bab1",
	"./reports/243.food.svg": "f0d0",
	"./reports/244.room_conditions.svg": "dfe2",
	"./reports/245.Kindness_sensitivity.svg": "1246",
	"./reports/246.Explain_process.svg": "6f5e",
	"./reports/247.Personal_attention.svg": "d715",
	"./reports/37.like.svg": "2b2c",
	"./reports/39.like.svg": "d0de",
	"./reports/402.services.svg": "ea68",
	"./reports/509.operating_instructions.svg": "83cb",
	"./reports/510.general.svg": "0828",
	"./reports/511.connection_problem.svg": "576d",
	"./reports/512.lighting.svg": "5c74",
	"./reports/54.full_garbage_can.svg": "03b9",
	"./reports/60.status_toilet_paper.svg": "850b",
	"./reports/65.status_head_paper.svg": "4a24",
	"./reports/7.bad_smell.svg": "e576",
	"./reports/70.status_soap.svg": "648b",
	"./reports/75.status_garbage_can.svg": "94d5",
	"./reports/8.dirty_floor.svg": "779e",
	"./reports/80.cleaning.svg": "bd2e",
	"./reports/80.general_cleaning.svg": "04f1",
	"./reports/85.head_coverage.svg": "33ae",
	"./reports/86.something_else.svg": "e3eb",
	"./reports/87.missing_clothing.svg": "7bb7",
	"./reports/9.dirty_lavatory_seat.svg": "b320",
	"./smileys/130.need_improved.svg": "db7b",
	"./smileys/131.liked.svg": "a863",
	"./smileys/132.pleasant.svg": "6eb3",
	"./smileys/36.very_good.svg": "2704",
	"./smileys/37.excellent.svg": "1ef9",
	"./smileys/38.good.svg": "fb85",
	"./smileys/39.like.svg": "b50d",
	"./smileys/40.needs_improvement.svg": "3ebb",
	"./smileys/41.not_good.svg": "1399",
	"./survey/109.professionalism.svg": "41ce",
	"./survey/110.the_attitude_of_the_epresentative.svg": "8ba7",
	"./survey/111.waiting_time_for_service.svg": "cfe8",
	"./survey/112.other_aspect_of_service.svg": "4cb3",
	"./survey/113.language_of_the_service.svg": "53df",
	"./survey/114.rocedure_for_making_an_appointment.svg": "0757",
	"./survey/115.physical_conditions.svg": "6213",
	"./survey/120.found_another.svg": "0049",
	"./survey/121.found_similar.svg": "558d",
	"./survey/122.did_not_find.svg": "ee11",
	"./survey/123.found.svg": "af91",
	"./survey/140.eilat_resident.svg": "d80d",
	"./survey/141.once_a_week.svg": "b1cb",
	"./survey/142.once_a_month.svg": "791d",
	"./survey/143.twice_a_year.svg": "723d",
	"./survey/144.once_a_year.svg": "4a1f",
	"./survey/145.something_else.svg": "c79a",
	"./survey/150.friend.svg": "b56d",
	"./survey/151.newspaper.svg": "99d4",
	"./survey/152.google.svg": "37be",
	"./survey/153.zap.svg": "3327e",
	"./survey/160.vacuum_cleaner.svg": "46ef",
	"./survey/161.gaming_consoles.svg": "df25",
	"./survey/162.laptop.svg": "4ad7",
	"./survey/163.cellular.svg": "7538",
	"./survey/164.shop.svg": "ea14",
	"./survey/165.general_cleaning.svg": "6eb5",
	"./survey/166.restaurant_complex_cleaning.svg": "ffe7",
	"./survey/250.service_problem.svg": "41cc",
	"./survey/251.welcome_you.svg": "738f",
	"./survey/252.invoice_submitted.svg": "d926",
	"./survey/253.thank_you_bought.svg": "1029",
	"./survey/254.problem_seller.svg": "a390",
	"./survey/255.lapel_pin.svg": "8d19",
	"./survey/256.proper_performance.svg": "8ca4",
	"./survey/257.name_tag.svg": "d4b6",
	"./survey/258.operational.svg": "fbce",
	"./survey/259.app_revealed.svg": "c399",
	"./survey/260.register_load.svg": "fdbd",
	"./survey/261.visibility_problem.svg": "cdcb",
	"./survey/262.clean_storefront.svg": "1712",
	"./survey/263.clean_garbage.svg": "17a8",
	"./survey/264.clean_tables_chairs.svg": "3d8e",
	"./survey/265.clean_shop_floor.svg": "c6f4",
	"./survey/266.product_show.svg": "2ca5",
	"./survey/267.refrigerators_show.svg": "82c2",
	"./survey/268.coffee_accessories.svg": "431b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "372d";